import {
  useBoolean,
  useToastr,
} from '@laxmimanogna/code-quick-components';
import React, { createContext, useState } from 'react';
import dashboardRepository from '../repositories/DashboardRepository';
import hospitalDashboardRepository from '../repositories/HospitalRepository';

export const HospitalDashboardContext = createContext({
  // async functions
  getHospital: async hospitalId => { },

  // states
  hospital: {},

  // booleans
  isFetchingHospital: false,
  isAccessDenied: true,
  getRVUOpp: async () => { },
  rvuOpp: {},
  isRvuLoading: false,
  getOutstandingRevenue: async () => { },
  outstandingRevenue: {},
  getAIRisk: async () => { },
  aiRisk: {},
  isAIRiskLoading: false,
  error: {},

  cqScore: {},
  setCQScore: () => {},
});

function HospitalProvider(props) {
  const toast = useToastr();

  const [hospital, setHospital] = useState({});
  const [isFetchingHospital, ifhState] = useBoolean(false);
  const [isAccessDenied, setAccessDeniedState] = useBoolean(true);
  const [rvuOpp, setRvuOpp] = useState({});
  const [outstandingRevenue, setOutstandingRevenue] = useState({});
  const [isRvuLoading, iRVUState] = useBoolean(false)
  const [isAIRiskLoading, iarlState] = useBoolean(false)

  const [aiRisk, setAIRisk] = useState({})
  const [cqScore, setCQScore] = useState({'start_date':null, 'end_date':null})
  const [error, setError] = useState({
    TOTAL_UPLOADS: '',
    CQ_SCORE: '',
    RVU_OPPORTUNITY: '',
    AI_RISK: ''
  })

  const getHospital = async hospitalId => {
    try {
      ifhState.on();
      const response =
        await hospitalDashboardRepository.getHospitalForDashboard(hospitalId);
      setHospital(response);
      setAccessDeniedState.off();
      return response;
    } catch (err) {
      if(err?.cause?.detail === "access_denied"){
        setAccessDeniedState.on();
      }
      else{
        toast.showError({
          description: `Something went wrong`,
        });
      }
    } finally {
      ifhState.off();
    }
  };

  const getRVUOpp = async (filterParams) => {
    try {
      iRVUState.on()
      const response = await hospitalDashboardRepository.getRevenueOpportunity(
        filterParams
      );
      setRvuOpp(response);
    } catch (err) {
      // console.log(err)
    } finally {
      iRVUState.off()
    }
  }

  const getOutstandingRevenue = async (filterParams) => {
    try {
      const response = await hospitalDashboardRepository.getOutstandingRevenue(
        filterParams
      );
      setOutstandingRevenue(response);
    } catch (err) {
    } finally {
    }
  }

  const getAIRisk = async (filter) => {
    try {
      iarlState.on();
      const response = await dashboardRepository.getAIRisk(filter);
      setAIRisk({ ...response, label: 'Departments' })
    } catch (err) {
      const response = err.cause;
      if (response.message) {
        setError(prev => ({ ...prev, AI_RISK: response.message }))
      }
    } finally {
      iarlState.off();
    }
  }

  const mContext = {
    getHospital,
    hospital,
    isFetchingHospital,
    isAccessDenied,
    getRVUOpp,
    rvuOpp,
    isRvuLoading,
    getOutstandingRevenue,
    outstandingRevenue,
    getAIRisk,
    aiRisk,
    isAIRiskLoading,
    error,

    cqScore,
    setCQScore,
  };

  return (
    <HospitalDashboardContext.Provider value={mContext}>
      {props.children}
    </HospitalDashboardContext.Provider>
  );
}

export default HospitalProvider;
